import { render, staticRenderFns } from "./Ranking2.vue?vue&type=template&id=afa2ca82&scoped=true"
import script from "./Ranking2.vue?vue&type=script&lang=js"
export * from "./Ranking2.vue?vue&type=script&lang=js"
import style0 from "./Ranking2.vue?vue&type=style&index=0&id=afa2ca82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa2ca82",
  null
  
)

export default component.exports